<template>
  <div class="clearfix">
    <!-- 왼쪽 -->
    <div
      :id="`${getActivityAreaId(leftSide)}-normal`"
      class="floL"
      :class="{ marTML: rowIdx > 0 }"
    >
      <p class="fntH6 fntL bold padBSM" style="color:#2c2c2c;">{{ leftSide.name }}님의 액티비티</p>
      <div class="amway-theme">
        <div class="radio-wrapper NCAcmi_cont03_radio NCAcmi_radioBtn">
          <!-- 일반 액티비티 영역 -->
          <SurveyActivityExample
            v-for="example in normalExamples"
            :key="`row${rowIdx}_left_${example.se_code}`"
            :examples="normalExamples"
            :example="example"
            :attendant="leftSide"
            :unique="`${sqCode}_row${rowIdx}_left`"
          />
          <!-- vip 액티비티가 노출되는 경우 일반 액티비티에 "선택 안함" 선택지 노출 => 모든 경우에 선택 안함 추가 -->
          <SurveyActivityExample
            :examples="normalExamples"
            :example="noneExample"
            :attendant="leftSide"
            :unique="`${sqCode}_row${rowIdx}_left`"
          />
        </div>
      </div>

      <!-- VIP 액티비티 영역 -->
      <template v-if="showVipExamples(leftSide)">
        <hr style="border-bottom:1px dashed #e3e3e3">
        <p
          :id="`${getActivityAreaId(leftSide)}-vip`"
          class="fntH6 fntL bold padBSM"
          style="color:#2c2c2c;"
        >VIP 전용 액티비티</p>
        <SurveyActivityExampleVip
          v-for="(example, vipIdx) in vipExamples"
          :key="`row${rowIdx}_left_vip_${example.se_code}`"
          :example="example"
          :attendant="leftSide"
          :unique="`row${rowIdx}_left_vip_${example.se_code}`"
          :is-top="vipIdx === 0"
        />
      </template>
    </div>
    <template v-if="rightSide">
      <hr class="moOnly" style="border-top:1px solid #e3e3e3;" />
      <!-- 오른쪽 -->
      <div
        :id="`${getActivityAreaId(rightSide)}-normal`"
        class="floR"
        :class="{ marTML: rowIdx > 0 }"
      >
        <p class="fntH6 fntL bold padBSM" style="color:#2c2c2c;">{{ rightSide.name }}님의 액티비티</p>
        <div class="amway-theme">
          <div class="radio-wrapper NCAcmi_cont03_radio NCAcmi_radioBtn">
            <!-- 일반 액티비티 영역 -->
            <SurveyActivityExample
              v-for="example in normalExamples"
              :key="`row${rowIdx}_right_${example.se_code}`"
              :examples="normalExamples"
              :example="example"
              :attendant="rightSide"
              :unique="`${sqCode}_row${rowIdx}_right`"
            />
            <!-- vip 액티비티가 노출되는 경우 일반 액티비티에 "선택 안함" 선택지 노출 => 모든 경우에 선택 안함 추가 -->
            <SurveyActivityExample
              :examples="normalExamples"
              :example="noneExample"
              :attendant="rightSide"
              :unique="`${sqCode}_row${rowIdx}_right`"
            />
          </div>
        </div>

        <template v-if="showVipExamples(rightSide)">
          <!-- VIP 액티비티 영역 -->
          <hr style="border-bottom:1px dashed #e3e3e3">
          <p
            :id="`${getActivityAreaId(rightSide)}-vip`"
            class="fntH6 fntL bold padBSM"
            style="color:#2c2c2c;"
          >VIP 전용 액티비티</p>
          <SurveyActivityExampleVip
            v-for="(example, vipIdx) in vipExamples"
            :key="`row${rowIdx}_right_vip_${example.se_code}`"
            :example="example"
            :attendant="rightSide"
            :unique="`row${rowIdx}_right_vip_${example.se_code}`"
            :is-top="vipIdx === 0"
          />
        </template>
      </div>
      <hr v-if="showBottomHr" class="moOnly" style="border-top:1px solid #e3e3e3;" />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY, IS_VIP } from '@/store/actions/survey'
import { CommonMethodMixin } from '../mixins'
import SurveyActivityExample from './SurveyActivityExample.vue'
import SurveyActivityExampleVip from './SurveyActivityExampleVip.vue'

export default {
  name: 'SurveyActivityPair',
  mixins: [CommonMethodMixin],
  components: {
    SurveyActivityExample,
    SurveyActivityExampleVip
  },
  props: {
    rowIdx: {
      type: Number,
      required: true
    },
    leftSide: {
      type: Object,
      required: true
    },
    rightSide: {
      type: Object,
      default: null
    },
    activity: {
      type: Object,
      required: true
    },
    showBottomHr: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(SURVEY, {
      pinLevel: state => state.pin_level
    }),
    ...mapGetters(SURVEY, {
      isVip: IS_VIP
    }),
    sqCode() {
      return this.activity.sq_code;
    },
    // 액티비티 문항
    examples() {
      return Object.keys(this.activity.examples).map(se_code => this.activity.examples[se_code]);
    },
    // 액티비티 일반 문항
    normalExamples() {
      return this.examples.filter(example => !example.pin);
    },
    // 액티비티 VIP 문항
    vipExamples() {
      return this.examples.filter(example => example.pin !== null && (Number(example.pin) <= Number(this.pinLevel || '')));
    },
    noneExample() {
      return {
        sq_code: this.sqCode,
        se_code: '',
        display_text: this.isVip ? '선택안함 (VIP 액티비티 진행 예정)' : '선택안함',
        value: '선택안함',
        remain_num: null,
        pin: null
      };
    }
  },
  methods: {
    getActivityAreaId(attendant) {
      const uniqueType = attendant.type + (attendant.type_seq || '');
      return `${this.sqCode}-${uniqueType}`
    },
    // VIP 문항 노출 조건
    showVipExamples(attendant) {
      return attendant.type !== 'F' && this.vipExamples.length > 0;
    }
  },
}
</script>

<style scoped>
/* 모바일 화면에서 marTML으로 인해 빈 공간 생기는 현상 수정 */
@media screen and (max-width:639px) {
  .clearfix .floL.marTML, .clearfix .floR.marTML {
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyActivityPair.vue